<template>
  <a-modal
    title="新增标准工艺路线"
    :visible="visible"
    :width="600"
    :maskClosable="false"
    :confirmLoading="loading"
    okText="提交"
    @cancel="onClose"
    @ok="onConfirm"
  >
    <a-form :form="form" autoComplete="off" :wrapperCol="{ span: 19 }" :labelCol="{ span: 5 }">
      <a-form-item label="加工组织">
        <global-select
          selectType="selectAssemble"
          requestApi="/system/user/inventOrgAll"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :dropdown-match-select-width="false"
          v-decorator="['organizationCode', { rules: [baseRequiredRule] }]"
          :assembleLabel="true"
          placeholder="请选择"
        />
      </a-form-item>
      <a-form-item label="工艺路线编码">
        <a-input v-decorator="['routingCode', { rules: [baseRequiredRule] }]" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="工艺路线名称">
        <a-input v-decorator="['routingDesc', { rules: [baseRequiredRule] }]" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="是否默认">
        <a-select v-decorator="['defaultIs', { rules: [baseRequiredRule] }]">
          <a-select-option value="Y">是</a-select-option>
          <a-select-option value="N">否</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { STATUS_CODE } from '../enums.js';
import { apiAddStandardProcess } from '@/api/mes/basedata/standardProcessNew'
export default {
  name: 'AddModal',
  components: {},
  props: {
    mainBtnLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.inputRequiredRule = { required: true, message: ' ', whitespace: true }
    this.baseRequiredRule = { required: true, message: ' ' }
    return {
      loading: false,
      visible: false,
      form: this.$form.createForm(this, { name: 'add-modal-form' })
    }
  },
  computed: {
    STATUS_CODE() {
      return STATUS_CODE;
    },
    statusOptions() {
      return Object.values(STATUS_CODE)
    }
  },
  methods: {
    show() {
      this.visible = true
      this.loading = false;
      this.$nextTick(() => {
        this.form.resetFields();
        this.form.setFieldsValue({ defaultIs: 'N' }) // 是否默认设为否
      })
    },
    onConfirm() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$emit('update:mainBtnLoading', true)
          apiAddStandardProcess(values)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('操作成功')
                this.onClose()
                this.$emit('successCall')
              }
            })
            .finally(() => {
              this.loading = false
              this.$emit('update:mainBtnLoading', false)
            })
        }
      })
    },
    onClose() {
      this.visible = false;
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-form-explain {
  position: absolute;
  font-size: 12px;
  line-height: 1.5em;
}
/deep/.ant-form-item {
  margin: 0px;
}
</style>
